import React, { useRef } from "react";
import { Badge, IconButton, WrapItem } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { useDrag, useDrop } from "react-dnd";
import CustomizationTooltip from "./CustomizationTooltip/CustomizationTooltip";

const ItemTypes = {
  CUSTOMIZATION: "customization",
};

const DraggableCustomization = ({
  customization,
  index,
  moveCustomization,
  onCustomizationClick,
  handleRemoveCustomization,
}) => {
  const ref = useRef(null);
  const dragPreviewRef = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    type: ItemTypes.CUSTOMIZATION,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: ItemTypes.CUSTOMIZATION,
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveCustomization(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));
  preview(dragPreviewRef);

  return (
    <>
      <WrapItem ref={ref}>
        <CustomizationTooltip
          key={customization.id}
          modifierGroupText="Modifier Group"
          customizationName={customization.customization}
          options={customization?.option}
          placement="top"
        >
          <Badge
            display="flex"
            ref={dragPreviewRef}
            opacity={isDragging ? 0.2 : 1}
            alignItems="center"
            p={2}
            borderRadius="full"
            variant="solid"
            colorScheme="green"
            cursor={"pointer"}
            onClick={() => {
              onCustomizationClick(customization.id);
            }}
          >
            {customization.customization || "unnamed customization"}
            <IconButton
              icon={<CloseIcon />}
              size="xs"
              ml={2}
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveCustomization(customization.id);
              }}
              variant="unstyled"
              aria-label="Remove Customization"
              _hover={{ color: "red.500" }}
            />
          </Badge>
        </CustomizationTooltip>
      </WrapItem>
    </>
  );
};

export default DraggableCustomization; 